import { SimpleTable } from '@tassat/ag-grid';
import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getApiOpsOverviewDashboardStats } from 'Selectors/statistics';

import { columnDefs } from './overviewStatsGridOptions';

const OverviewStatsTable: React.FC = () => {
    const overviewStats = useAppSelector((state) => getApiOpsOverviewDashboardStats(state, undefined, undefined));
    const statsData = React.useMemo(() => {
        return [
            {
                type: 'API Firms',
                total: overviewStats.apiFirms,
                locked: overviewStats.lockedApiFirms
            },
            {
                type: 'API Users',
                total: overviewStats.apiUsers,
                locked: overviewStats.lockedApiUsers
            },
            {
                type: 'API Connections',
                total: overviewStats.apiConnections,
                locked: overviewStats.lockedApiConnections
            }
        ];
    }, [overviewStats]);

    return (
        <>
            <SimpleTable
                columnDefs={columnDefs}
                minHeight={120}
                rowData={statsData}
                title='Overview'
            />
        </>
    );
};

export default OverviewStatsTable;